
import { api } from "shared/src/constants/api";

export const sendInvite = (supplierId, inviteId, token) => {
    const url = api.sendContractorInvitation(supplierId, inviteId);
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${token}`);
    return fetch(url, {headers})
}